import { ActivatedRouteSnapshot, BaseRouteReuseStrategy } from '@angular/router';

/** Route `data` flag: the route's page belongs to the project in its `:id` and must not serve another one. */
export const RECREATE_ON_PROJECT_CHANGE = 'recreateOnProjectChange';

/**
 * REV-22579: Angular keeps a page when only a route parameter changes. Moving from project A to project B
 * inside the app (browser back/forward, a link) then kept A's report pages, and many of them read the active
 * report id only once — the save sent B's report with A's id. A route marked with
 * {@link RECREATE_ON_PROJECT_CHANGE} is created anew, with all its child pages, when its `:id` changes.
 * Every other route keeps Angular's default behaviour.
 */
export class ProjectRouteReuseStrategy extends BaseRouteReuseStrategy {
    override shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
        if (!super.shouldReuseRoute(future, curr)) {
            return false;
        }
        return !(future.data?.[RECREATE_ON_PROJECT_CHANGE] && future.paramMap.get('id') !== curr.paramMap.get('id'));
    }
}
